import amaKvadrato from './ama_kvadrato';
import rokOpero from './rok_opero';
import mondoTeatro from './la_tuta_mondo_estas_teatro';

const list = [
  amaKvadrato,
  mondoTeatro,
  rokOpero,
];

export default list;